import { AdvancedSelect } from '@orobix/orobix-fe-components'
import { useField, useFormikContext } from 'formik'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { SelectOption } from './types'
import { usePatchStrategiesData } from './usePatchStrategiesData'
import { patchStrategyToOption } from './utils'

export interface PatchStrategySelectProps {
  fieldName: string
}

const PatchStrategySelect = ({ fieldName }: PatchStrategySelectProps) => {
  const { t } = useTranslation()
  const { isSubmitting } = useFormikContext()
  const [field, meta, helpers] = useField<SelectOption>(fieldName)

  const { name, value } = field
  const { error, touched } = meta
  const { setValue, setTouched } = helpers

  const {
    patchStrategies,
    patchStrategiesIsLoading,
    patchSrategyDft,
  } = usePatchStrategiesData()

  const toOption = patchStrategyToOption()

  useEffect(() => {
    if (!patchStrategiesIsLoading && patchSrategyDft) {
      setValue(toOption(patchSrategyDft))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patchStrategiesIsLoading, patchSrategyDft])

  return (
    <div id="divPatchStrategyId">
      <AdvancedSelect
        name={name}
        id={name}
        label={t('Patch strategy')}
        value={value}
        onChange={(v: SelectOption | null) => v && setValue(v)}
        onBlur={() => setTouched(true)}
        options={patchStrategies ? patchStrategies.map(toOption) : []}
        error={!!(error && touched)}
        errorMessage={error}
        isDisabled={isSubmitting || patchStrategiesIsLoading}
        noOptionsMessage={() => t('No patch strategy found')}
        placeholder={
          patchStrategiesIsLoading ? t('Loading options...') : t('Select...')
        }
      />
    </div>
  )
}

export default PatchStrategySelect
